<template>
  <v-card
    class="py-2 item"
    v-bind="getLinkAttrs(to)"
    max-width="210px"
    width="100%"
    flat
    tile
  >
    <v-sheet
      class="pa-7 mx-auto rounded-circle item-img-container"
      width="138px"
    >
      <img
        class="d-block item-img"
        :src="files + img + '?resize=1&w=80'"
        :alt="title"
        width="100%"
      />
    </v-sheet>

    <div
      class="
        grey--text
        text-body-1 text-md-h6 text-center
        font-weight-medium
        mt-4 mt-md-6
      "
    >
      {{ title }}
    </div>
  </v-card>
</template>

<script>
import { getLinkAttrs } from "../../utils/getLinkAttrs";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    getLinkAttrs,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img-container {
    border: 3px solid var(--v-secondary-base) !important;
  }

  &-img {
    aspect-ratio: 1;
    object-fit: contain;
  }
}
</style>
